module.exports = "<div class=\"mensagem-erro-input\">\n  <span class=\"sr-only\">Erro:</span>\n  <ng-transclude></ng-transclude>\n</div>\n";